import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles';
import { ReactComponent as NewLoopIcon } from '../../images/new-loop.svg'
import useWindowSize from '../../hooks/window-size'
import Editor from '../editor/Editor'
import { observer } from "mobx-react-lite"

import { setConfig, resetEditor } from '../editor/editorSlice'
import { useDispatch } from 'react-redux'
import StyledThemeProvider from '../../components/StyledThemeProvider'
import usePlayer from '../common/usePlayer'
import { useTipsEditor } from '../loops/ctx';

const useStyles = makeStyles({
  root: {
    background: '#FFF',
    border: 0,
    borderRadius: 28,
    boxShadow: '0px 5px 12px 0px #AAAAAA',
    padding: '0 30px 0 14px',
    position: 'fixed',
    zIndex: 1000,
    height: 55,
    textTransform: 'none',
    '&:hover': {
      background: '#FFF',
    },
    fontSize: 18,
    fontFamily: '"Futura Bold", Futura',
  },
  startIcon: {
    marginRight: 15,
  }
});

const usePosition = () => {
  const size = useWindowSize();
  const defaultTop = size.height * 0.8;
  const top = defaultTop + 60 > size.height ? size.height - 60 : defaultTop;
  const defaultRight = (size.width - 1180) / 2 - 40;
  const right = defaultRight < 5 ? 5 : defaultRight;

  return {right: `calc((100% - 100vw) + ${right}px)`, top: top}
}

const NewLoop = observer(({className, pack, config, handlePosition, loopsModel}) => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const position = usePosition()
  const { playType } = usePlayer()
  const { setTipsEditor } = useTipsEditor()

  useEffect(() => {
    if (loopsModel.editorOpen) {
      dispatch(resetEditor())
    }
    if (loopsModel.editorOpen && config) {
      dispatch(setConfig(config))
      playType(null)
    }
  }, [loopsModel.editorOpen, config, dispatch])

  useEffect(() => {
    handlePosition && handlePosition({...position})
  }, [position.top, position.right])

  const onShow = () => {
    loopsModel.setEditorOpen(true)
    setTipsEditor('1')
  }

  const close = (toMyLoops) => {
    loopsModel.setEditorOpen(false)
    toMyLoops && loopsModel.toMyLoops()
  }
  
  return <><Button classes={classes} className={className} startIcon={<NewLoopIcon />} style={{...position}} onClick={onShow}>
    New Loop
  </Button>
  <StyledThemeProvider scope="editor">
    <Editor open={loopsModel.editorOpen} onClose={close} name={"New Loop"} packId={pack.id} preview={pack.preview}/>
  </StyledThemeProvider>
  </>
})

export default NewLoop 